export default "__VITE_ASSET__49c7e6ac__"